import React, { useEffect } from "react";
import { Link } from "react-router-dom";

// Thank-you page shown after a FREE DEMO booking.
// URL: /demo-confirmed  — use this URL for Google Ads conversion tracking.
export default function DemoConfirmed() {
  useEffect(() => {
    document.title = "Demo Booked | Xplooreze";
    // --- GOOGLE ADS CONVERSION (demo) ---
    // If your Ads manager gives you a demo conversion snippet, paste it here:
    // window.gtag && window.gtag('event', 'conversion', {
    //   send_to: 'AW-18317761317/XXXXXXXXXXX',
    // });
  }, []);

  return (
    <div style={styles.wrap}>
      <div style={styles.card}>
        <img src="/app-logo-black.png" alt="Xplooreze" style={styles.logo} />
        <span style={styles.badge}>Free Demo</span>
        <div style={styles.tick}>✓</div>
        <h1 style={styles.h1}>Your free demo is booked!</h1>
        <p style={styles.p}>
          Thank you for booking a free demo class on Xplooreze. Our team will
          confirm the details with you shortly. Please keep an eye on your email
          and phone.
        </p>
        <div style={styles.row}>
          <Link to="/student-classes" style={styles.primary}>View my classes</Link>
          <Link to="/" style={styles.secondary}>Back to home</Link>
        </div>
        <p style={styles.help}>Need help? Get in touch:</p>
        <div style={styles.contactRow}>
          <a href="mailto:hello.xplooreze@gmail.com" style={styles.contactBtn}>
            ✉️ Email us
          </a>
          <a
            href="https://wa.me/919945693172"
            target="_blank"
            rel="noreferrer"
            style={styles.whatsappBtn}
          >
            💬 WhatsApp
          </a>
        </div>
      </div>
    </div>
  );
}

const styles = {
  wrap: {
    minHeight: "70vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "40px 16px",
    background: "#FFF7ED",
  },
  card: {
    width: "100%",
    maxWidth: 560,
    background: "#fff",
    borderRadius: 24,
    padding: "40px 32px",
    boxShadow: "0 18px 48px rgba(237,90,9,0.14)",
    border: "1px solid #FED7AA",
    // center every child horizontally
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
  },
  logo: { display: "block", height: 34, marginBottom: 18 },
  badge: {
    display: "inline-block",
    background: "#FFF3E9",
    color: "#C2410C",
    border: "1px solid #FED7AA",
    borderRadius: 999,
    padding: "6px 14px",
    fontSize: 12,
    fontWeight: 800,
    marginBottom: 18,
  },
  tick: {
    width: 72,
    height: 72,
    borderRadius: "50%",
    background: "linear-gradient(135deg,#F97316,#ED5A09,#F59E0B)",
    color: "#fff",
    fontSize: 38,
    fontWeight: 900,
    lineHeight: "72px",
    textAlign: "center",
    marginBottom: 18,
  },
  h1: { fontSize: 26, fontWeight: 900, color: "#1C1917", margin: "0 0 10px" },
  p: { fontSize: 15, lineHeight: 1.6, color: "#57534E", margin: "0 0 24px", maxWidth: 460 },
  row: { display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap", marginBottom: 18 },
  primary: {
    display: "inline-block",
    background: "#ED5A09",
    color: "#fff",
    textDecoration: "none",
    borderRadius: 999,
    padding: "12px 24px",
    fontSize: 15,
    fontWeight: 800,
  },
  secondary: {
    display: "inline-block",
    background: "#fff",
    color: "#ED5A09",
    border: "1px solid #ED5A09",
    textDecoration: "none",
    borderRadius: 999,
    padding: "12px 24px",
    fontSize: 15,
    fontWeight: 800,
  },
  help: { fontSize: 13, color: "#A8A29E", margin: "0 0 12px", maxWidth: 460 },
  link: { color: "#ED5A09", textDecoration: "none", fontWeight: 700 },
  contactRow: { display: "flex", gap: 10, justifyContent: "center", flexWrap: "wrap" },
  contactBtn: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    background: "#FFF3E9",
    color: "#C2410C",
    border: "1px solid #FED7AA",
    textDecoration: "none",
    borderRadius: 999,
    padding: "8px 16px",
    fontSize: 13,
    fontWeight: 800,
  },
  whatsappBtn: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    background: "#25D366",
    color: "#fff",
    textDecoration: "none",
    borderRadius: 999,
    padding: "8px 16px",
    fontSize: 13,
    fontWeight: 800,
  },
};
